import type { ReactNode } from 'react'

/**
 * Padding and scrolling for ordinary reading pages.
 *
 * `<main>` is `overflow-hidden` because the Unterlagen matrix manages its own
 * scroll container; without this wrapper every other page inherits that clip and
 * silently loses anything below the fold.
 */
export function PageShell({
  children,
  /** Reading pages stay narrow; a workspace with two columns needs the room. */
  width = 'reading',
}: {
  children: ReactNode
  width?: 'reading' | 'wide'
}) {
  return (
    <div className="h-full overflow-auto px-6 py-8">
      {/* Left-aligned, not centred: Unterlagen starts hard left, and a centred
          column would make the content jump sideways when switching pages. */}
      <div className={width === 'wide' ? 'max-w-6xl' : 'max-w-3xl'}>{children}</div>
    </div>
  )
}
